<template>
	<div class="card history accordion-item" :id="itemId" ref="item">
		<div
			v-if="hasHeader"
			:class="['card-header', 'accordion-header', {'cursor-pointer': isCollapsible}]"
			:id="headingId"
			@click.prevent="toggle">
			<div class="row align-items-center no-gutters">
				<div class="col" >
					<slot name="header"></slot>
				</div>
				<div class="col-auto pl-3" v-if="showRemoveButton || showArrow">
					<span class="icon" v-if="showRemoveButton" @click.stop="onRemove">
						<i class="fas fa-xmark"></i>
					</span>
					<span class="icon" v-if="showArrow">
						<i class="fas" :class="[show ? 'fa-angle-up' : 'fa-angle-down']"></i>
					</span>
				</div>
			</div>
		</div>
		<div
			:class="['accordion-content', { show, collapsing }]"
			:id="collapseId"
			:style="heightStyle"
			ref="content">
			<div class="card-body accordion-content-inner" :class="classBody">
				<slot name="body"></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CardHistory',
	props: {
		startOpen: {
			type: Boolean,
			default: false
		},
		isCollapsible: {
			type: Boolean,
			default: true
		},
		showArrow: {
			type: Boolean,
			default: true
		},
		showRemoveButton: {
			type: Boolean,
			default: false
		},
		classBody: {
			type: String,
			default: ''
		},
	},
	data() {
		return {
			id: this._uid,
			show: false,
			collapsing: false,
			height: null,
		}
	},
	computed: {
		hasHeader() {
			return !!this.$slots.header
		},
		heightStyle() {
			if (this.height !== null) {
				return `height: ${this.height}px;`
			}
			return ''
		},
		itemId: function() {
			return `accordion-item-${this.id}`
		},
		headingId: function() {
			return `heading-${this.id}`
		},
		collapseId: function() {
			if(!this.isCollapsible) return null;
			return `collapse-${this.id}`
		},
	},
	methods: {
		collapse: function() {
			this.height = this.$refs.content.scrollHeight;
			this.collapsing = true;
			this.show = false;

			setTimeout(() => {
				this.height = null
			}, 5);

			setTimeout(() => {
				this.show = false
				this.collapsing = false
			}, 200);
		},
		toggle: function() {
			if(this.isCollapsible) {
				if (this.collapsing) return;

				this.$emit('toggle', !this.show);

				if (!this.show && this.autoScroll) {
					setTimeout(() => {
						window.scrollTo({
							top: this.$refs.item.offsetTop - 8,
							behavior: 'smooth'
						});
					}, 250);
				}

				if (!this.show) {
					if (!this.$parent.multiple) {
						this.$parent.$children.forEach(component => {
							if (component !== this) {
								component.collapse();
							}
						})
					}

					this.collapsing = true;
					this.$nextTick(() => {
						this.height = this.$refs.content.scrollHeight;
					})
					setTimeout(() => {
						this.show = true;
						this.height = null;
						this.collapsing = false;
					}, 200);
				} else {
					this.collapse();
				}
			}
		},
		onRemove: function() {
			this.$emit('remove')
		}
	},
	watch: {
		startOpen: {
			immediate: true,
			handler: function(newValue, oldValue) {
				if(newValue) {
					this.toggle()
				}
			}
		}
	}
}
</script>

<style scoped>
.accordion-content {
	transition: height 200ms ease;
}
.accordion-content:not(.show):not(.collapsing) {
	display: none;
}
.accordion-content.collapsing {
	height: 0;
	overflow: hidden;
}
</style>